import config from 'mewe/config';

export default function notProd() {
  return config.environment != 'prod';
}
